/**
 * Country list shown in the registration dropdown.
 *
 * Aligned with the backend `COUNTRIES_ROSTER` in `server.py` — the 31
 * EASA member states covered by EU 2019/947. Order: France first (largest
 * user base), then alphabetical. An "Autre" escape hatch keeps signups
 * open for visitors outside the EASA area (UK, Serbia, etc.).
 */
export const REGISTER_COUNTRIES = [
  { code: 'fr', flag: '🇫🇷', label: 'France' },
  { code: 'de', flag: '🇩🇪', label: 'Allemagne' },
  { code: 'at', flag: '🇦🇹', label: 'Autriche' },
  { code: 'be', flag: '🇧🇪', label: 'Belgique' },
  { code: 'bg', flag: '🇧🇬', label: 'Bulgarie' },
  { code: 'cy', flag: '🇨🇾', label: 'Chypre' },
  { code: 'hr', flag: '🇭🇷', label: 'Croatie' },
  { code: 'dk', flag: '🇩🇰', label: 'Danemark' },
  { code: 'es', flag: '🇪🇸', label: 'Espagne' },
  { code: 'ee', flag: '🇪🇪', label: 'Estonie' },
  { code: 'fi', flag: '🇫🇮', label: 'Finlande' },
  { code: 'gr', flag: '🇬🇷', label: 'Grèce' },
  { code: 'hu', flag: '🇭🇺', label: 'Hongrie' },
  { code: 'is', flag: '🇮🇸', label: 'Islande' },
  { code: 'ie', flag: '🇮🇪', label: 'Irlande' },
  { code: 'it', flag: '🇮🇹', label: 'Italie' },
  { code: 'lv', flag: '🇱🇻', label: 'Lettonie' },
  { code: 'li', flag: '🇱🇮', label: 'Liechtenstein' },
  { code: 'lt', flag: '🇱🇹', label: 'Lituanie' },
  { code: 'lu', flag: '🇱🇺', label: 'Luxembourg' },
  { code: 'mt', flag: '🇲🇹', label: 'Malte' },
  { code: 'no', flag: '🇳🇴', label: 'Norvège' },
  { code: 'nl', flag: '🇳🇱', label: 'Pays-Bas' },
  { code: 'pl', flag: '🇵🇱', label: 'Pologne' },
  { code: 'pt', flag: '🇵🇹', label: 'Portugal' },
  { code: 'ro', flag: '🇷🇴', label: 'Roumanie' },
  { code: 'sk', flag: '🇸🇰', label: 'Slovaquie' },
  { code: 'si', flag: '🇸🇮', label: 'Slovénie' },
  { code: 'se', flag: '🇸🇪', label: 'Suède' },
  { code: 'ch', flag: '🇨🇭', label: 'Suisse' },
  { code: 'cz', flag: '🇨🇿', label: 'Tchéquie' },
  { code: 'other', flag: '🌍', label: 'Autre pays' },
];

export const SUPPORTED_REGISTER_CODES = new Set(
  REGISTER_COUNTRIES.filter((c) => c.code !== 'other').map((c) => c.code)
);
